import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical';

export type Alignment = 'start' | 'center' | 'end';

export const DEFAULT_ALIGNMENT: Alignment = 'start';

export interface SelectAlignmentPayload {
  alignment: Alignment;
}

export const SELECT_ALIGNMENT: LexicalCommand<SelectAlignmentPayload> = createCommand();

export function AlignmentPlugin({ onChange }: { onChange: (alignment: Alignment) => void }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<SelectAlignmentPayload>(
        SELECT_ALIGNMENT,
        ({ alignment }) => {
          onChange(alignment);

          return true;
        },
        COMMAND_PRIORITY_EDITOR
      )
    );
  }, [editor, onChange]);

  return null;
}
